var React = require('react');

function LearnMoreArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_288","data-name":"Group 288","transform":"translate(92.262 5861.204) rotate(180)"},[React.createElement("path",{"id":"Path_1","data-name":"Path 1","d":"M0,10.107,10.841,0,21.682,10.107","transform":"translate(69 5860.182) rotate(-90)","fill":"none","stroke":"#fff","strokeWidth":"3","key":0}),React.createElement("line",{"id":"Line_2","data-name":"Line 2","x2":"22.448","transform":"translate(69.813 5849.886)","fill":"none","stroke":"#fff","strokeWidth":"3","key":1})]));
}

LearnMoreArrow.defaultProps = {"width":"25.312","height":"23.727","viewBox":"0 0 25.312 23.727"};

module.exports = LearnMoreArrow;

LearnMoreArrow.default = LearnMoreArrow;
